import { Outlet } from 'react-router-dom';
import { SessionEndedBanner } from '@kss/auth';
import { WebHeader } from './WebHeader';
import { WebFooter } from './WebFooter';

export function WebLayout() {
  return (
    <div className="flex min-h-screen w-full max-w-full flex-col overflow-x-hidden bg-[var(--color-bg-app)] text-[var(--color-text-primary)]">
      <SessionEndedBanner />
      <WebHeader />
      <main className="w-full min-w-0 flex-1" style={{ marginTop: 3 }}>
        <Outlet />
      </main>
      <WebFooter />
    </div>
  );
}

export default WebLayout;
